import { cssEaseOutExpo } from "./easing";
import { breakpoints } from "@theme/breakpoints";

export const withLineHoverEffect = ({
  color,
  height,
  borderRadius,
  bottom,
  width,
}: {
  color?: string;
  height?: string;
  borderRadius?: string;
  bottom?: string;
  width?: string;
} = {}) => breakpoints.laptopMin`
    position: relative;
  
    ::before {
      width: ${width || "50%"};
      left: 50%;
      height: ${height || "2px"};
      background: ${({ theme }) => color || theme.foreground};
      position: absolute;
      content: "";
      bottom: ${bottom || "-4px"};
      transition: transform 0.5s ${cssEaseOutExpo};
      transform: translateX(-50%) scaleX(0);
      border-radius: ${borderRadius};
    }
  
    :hover::before {
      transform: translateX(-50%)  scaleX(1);
    }
`;
